export interface ParticipantExtractQuery {
  StartDate: Date|null,
  EndDate: Date|null,
  ProgramId: number,
  ProvinceId: number,
  BranchId:number
}

export function ParticipantExtractQueryDefaultValues():ParticipantExtractQuery
{
    return {
        StartDate:null,EndDate:null,ProgramId:0,ProvinceId:0,BranchId:0
    }
}
